import React, { useEffect } from 'react';
import { Box, Typography, Container, Link } from '@mui/material';
import LoadingButton from '@mui/material/Button';

import GlassCard from '../../customs/GlassCard';
import { CustomTextField } from '../../customs/CustomTextField';

import styles from './ParentPickup.module.css';
import { StyledEngineProvider } from '@mui/material/styles';
import Spinner from '../../layout/Spinner';

import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';

// Import useSelector and useDispatch to manage the global state
import { useSelector, useDispatch } from 'react-redux';
import ParentPickupHeader from './ParentPickupHeader';
import { getParentPickupInfo, updateParentPickup } from '../parentInfoSlice';

import { toast } from 'react-toastify';
import RenderTable from '../../customs/RenderTable';

const PickupScreen = () => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const dispatch = useDispatch();

  const { pickupId } = useParams();

  useEffect(() => {
    dispatch(getParentPickupInfo(pickupId));
  }, [dispatch, pickupId]);

  const parentInfo = useSelector((state) => state.parent.parentInfo);
  const {
    parentEntries,
    childrenEntries,
    loading,
    error,
    updateLoading,
    pickup,
  } = parentInfo;

  const onSubmit = (code) => {
    const data = { ...code, pickupId };
    dispatch(updateParentPickup(data))
      .unwrap()
      .then((message) => {
        dispatch(getParentPickupInfo(pickupId));
        toast.success(message);
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  if (error) {
    return (
      <StyledEngineProvider injectFirst>
        <ParentPickupHeader />
        <Container
          sx={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}
        >
          <GlassCard sx={{ width: 'fit-content' }}>
            <Typography variant='h5' component='h5' color='yellow'>
              {error}
            </Typography>
          </GlassCard>
        </Container>
        <Box sx={{ marginTop: '2rem' }} textAlign='center'>
          <Link href='/parent/pickup' color='secondary'>
            Search another one?
          </Link>
        </Box>
      </StyledEngineProvider>
    );
  }

  return (
    <StyledEngineProvider injectFirst>
      <ParentPickupHeader />
      {loading ? (
        <Spinner />
      ) : (
        <RenderPickupInfo
          parentEntries={parentEntries}
          childrenEntries={childrenEntries}
          pickup={pickup}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          register={register}
          errors={errors}
          updateLoading={updateLoading}
        />
      )}
      <Box sx={{ marginTop: '2rem' }} textAlign='center'>
        <Link href='/parent/pickup' color='secondary'>
          Search another one?
        </Link>
      </Box>
    </StyledEngineProvider>
  );
};

const RenderPickupInfo = ({
  parentEntries,
  childrenEntries,
  pickup,
  handleSubmit,
  onSubmit,
  register,
  errors,
  updateLoading,
}) => {
  return (
    <Container>
      <GlassCard
        sx={{ marginTop: '2rem', marginBottom: '2rem', width: '100%' }}
      >
        <Box>
          <Typography variant='h5' component='h5'>
            Your Contact Information
          </Typography>
        </Box>
      </GlassCard>
      <GlassCard sx={{ marginTop: '2rem', width: '100%' }}>
        <RenderTable entries={parentEntries} />
      </GlassCard>

      {childrenEntries.length > 0 && (
        <>
          <GlassCard
            sx={{ marginTop: '2rem', marginBottom: '2rem', width: '100%' }}
          >
            <Box>
              <Typography variant='h5' component='h5'>
                Your Angel(s) Information
              </Typography>
            </Box>
          </GlassCard>
          {childrenEntries.map((childEntries, index) => (
            <GlassCard key={index} sx={{ marginTop: '2rem', width: '100%' }}>
              <Box>
                <Typography
                  variant='h5'
                  component='h5'
                  sx={{ marginBottom: '1rem' }}
                >
                  Angel {index + 1}
                </Typography>
              </Box>

              <RenderTable cols={1} entries={childEntries} />
            </GlassCard>
          ))}
        </>
      )}

      {pickup ? (
        <></>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)} className={styles.adminTextBox}>
          <CustomTextField
            label='Admin Code'
            type='text'
            variant='outlined'
            focusColor='#EF9B14'
            {...register('confirmCode', { required: true })}
            helperText={
              errors?.confirmCode?.type === 'required' &&
              'Please input the admin code'
            }
          />

          <LoadingButton
            type='submit'
            color='secondary'
            size='large'
            variant='contained'
            loading={updateLoading}
          >
            Submit
          </LoadingButton>
        </form>
      )}
    </Container>
  );
};

export default PickupScreen;
